export default __webpack_public_path__ + "static/media/ILPlatform_Computer2.889617b4.webp";